(function() {
  'use strict';

  angular.module('app').factory('TanksService', TanksService);

  TanksService.$inject = ['$rootScope', 'API'];

  function TanksService($rootScope, API) {
    var service = {};
    /**
     * This callback type is called `requestCallback` and is displayed as a global symbol.
     *
     * @callback requestCallback
     * @param {boolean} success
     * @param {Object} data
     */
    /**
     * @typedef MultiLanguageObject
     * @type {Object}
     * @property {string} en - String on English
     * @property {string} pl - String on Polish
     * @property {string} ru - String on Russian
     * @property {string} uk - String on Ukrainian
     */

    /**
     * Return list of Tanks linked to the Business
     *
     * @param {object} params - Parameters
     * @param {string} params.page - List page number
     * @param {string} params.count - Objects on page
     * @param {string} params.owner_id - Owner Id filtering
     * @param {'customer' | 'corporate-customer'} params.owner_type - Owner type filtering
     * @param {string} params.code - Code filtering (matching criteria)
     * @param {string} params.search_text - Filter by search string (contains criteria) in main text fields (code, title, address, product_title)
     * @param {'all'|'yes'|'no'} params.active - Filter by active flag
     * @param {string} params.goods_code - Goods code filtering (matching criteria)
     * @param {'title'} params.sort - Sort field name
     * @param {'asc'|'desc'} params.order - Sort direction
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTanksLinked = function(params, callback) {
      API.get('/tanks/linked' + (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Add new link to tank
     *
     * @param {object} tank - Linked tank data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddTankLinked = function(tank, callback) {
      API.post('/tanks/linked', tank, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Delete link from tank
     *
     * @param {string} tankID - Tank Id
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeleteTankLinked = function(tankID, callback) {
      API.delete('/tanks/linked/' + tankID, {}, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return linked Tank info
     *
     * @param {string} tankID - Tank Id
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTankLinked = function(tankID, callback) {
      API.get('/tanks/linked/' + tankID, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify link to Tank
     *
     * @param {string} tankID - Tank Id
     * @param {object} tank - Linked tank data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateTankLinked = function(tankID, tank, callback) {
      API.patch('/tanks/linked/' + tankID, tank, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return list of Tanks for owner
     *
     * @param {string} ownerID - Owner Id
     * @param {object} params - Parameters
     * @param {string} params.code - Code filtering (matching criteria)
     * @param {string} params.search_text - Filter by search string (contains criteria) in main text fields (code, title, address, product_title)
     * @param {'all'|'yes'|'no'} params.active - Filter by active flag
     * @param {'title'} params.sort - Sort field name
     * @param {'asc'|'desc'} params.order - Sort direction
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTanks = function(ownerID, params, callback) {
      API.get('/tanks/owner/' + ownerID + (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Add Tank for owner
     *
     * @param {string} ownerID - Owner Id
     * @param {object} tank - Linked tank data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddTankForOwner = function(ownerID, tank, callback) {
      API.post('/tanks/owner/' + ownerID, tank, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Get Tank for owner
     *
     * @param {string} ownerID - Owner Id
     * @param {string} tankID - Tank Id
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTankForOwner = function(ownerID, tankID, callback) {
      API.get('/tanks/owner/' + ownerID + '/' + tankID, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify Tank for owner
     *
     * @param {string} ownerID - Owner Id
     * @param {string} tankID - Tank Id
     * @param tanks - Tanks data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateTankForOwner = function(ownerID, tankID, tanks, callback) {
      API.patch('/tanks/owner/' + ownerID + '/' + tankID, tanks, function(success, data) {
        callback(success, data);
      });
    };

    return service;
  }
})();
